import React from "react";
import Header, { HeaderProps } from "./Header";
import Footer, { FooterProps } from "./Footer";

export interface CardProps {
  children?: React.ReactNode | React.ReactNode[];
}

export interface CardCompound {
  Header: React.FC<HeaderProps>;
  Footer: React.FC<FooterProps>;
}

const Card: React.FC<CardProps> & CardCompound = ({ children }) => {
  return <div className="card">{children}</div>;
};

Card.Header = Header;
Card.Footer = Footer;

export default Card;
